/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import BackupTableIcon from '@mui/icons-material/BackupTable';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FolderIcon from '@mui/icons-material/Folder';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

type MuiIconsMaterialProps = any

export const ArgosCollapseNodeIcon = (props: MuiIconsMaterialProps) => {
  return (
    <ChevronRightIcon
      {...props}
    />
  )
}

export const ArgosDatasetIcon = (props: MuiIconsMaterialProps) => {
  return (
    <InsertDriveFileIcon
      {...props}
    />
  )
}

export const ArgosExpandNodeIcon = (props: MuiIconsMaterialProps) => {
  return (
    <ExpandMoreIcon
      {...props}
    />
  )
}

export const ArgosFolderIcon = (props: MuiIconsMaterialProps) => {
  return (
    <FolderIcon
      {...props}
    />
  )
}

export const ArgosStudyIcon = (props: MuiIconsMaterialProps) => {
  return (
    <BackupTableIcon
      {...props}
    />
  )
}
